import { Card, Table, TableBody, TableCell, TableHead, TableRow, TablePagination } from '@mui/material';
import { trainingSignalFields } from 'src/models/trainingSignal';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// import IconButton from '@mui/material/IconButton';
// import Tooltip from '@mui/material/Tooltip';
// import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
// import EditIcon from '@mui/icons-material/Edit';
import Link from '@mui/material/Link';

const TrainingSignalList = ({
  programs,
  page,
  pagesize,
  handleOnPageChange,
  handleLimitChange,
  totalTraingingSignals,
  removePrograms,
  open,
  onOpenModal,
  idProgram
}) => {
  const { t } = useTranslation();

  return (
    <Card>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>{trainingSignalFields.createdAt.label}</TableCell>
            <TableCell>{trainingSignalFields.student.label}</TableCell>

            <TableCell>PDF Result</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {programs &&
            programs.map((program) => (
              <TableRow key={program._id}>
                <TableCell>{program._id}</TableCell>
                <TableCell>{program.createdAt}</TableCell>
                <TableCell>{program.users?.fullName}</TableCell>
                <TableCell> {program.pdf && <Link href={program.pdf}>Link</Link>}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={totalTraingingSignals}
        onPageChange={handleOnPageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={pagesize}
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
      />
      <Dialog
        open={open}
        onClose={() => onOpenModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('dialog.title')}</DialogTitle>
        <DialogActions>
          <Button onClick={() => onOpenModal(false)}> {t('dialog.noButton')}</Button>
          <Button
            onClick={() => {
              removePrograms(idProgram);
              onOpenModal(false);
            }}
            autoFocus
          >
            {t('dialog.yesButton')}
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};
TrainingSignalList.propTypes = {
  programs: PropTypes.array,
  page: PropTypes.number,
  pagesize: PropTypes.number,
  totalTraingingSignals: PropTypes.number,
  open: PropTypes.bool,
  onOpenModal: PropTypes.func,
  idProgram: PropTypes.string,
  removePrograms: PropTypes.func,
  handleOnPageChange: PropTypes.func,
  handleLimitChange: PropTypes.func
};
export default TrainingSignalList;
